import * as React from "react";
import "./add-item-modal.less";
import { ModalComponent } from "shared/components/modal/modal";
import {
  formatMoney,
  redirectFileLocalUrl,
} from "shared/plugins/string-helper";
import {
  IProductItemSelectedModel,
  ShoppingCartItem,
} from "states/shopping-cart/shopping-cart.models";
import { IProductModel, IVariationAttributeModel, SelectGroupTypeEnum } from "states/menu/menu.models";
import { IconMinus, IconPlus, IconShoppingBag } from "themes";
import { calculateTotal } from "states/shopping-cart/shopping-cart.slice";
import { IVariationAttribute } from "./modal-add-cart";
import _ from "lodash";

interface IAddItemModelViewProps {
  openModal: boolean;
  addProduct: ShoppingCartItem;
  currentProductSelected: IProductItemSelectedModel;
  variationAttributes: IVariationAttribute[];
  isSelectedVariation: (va: IVariationAttributeModel) => boolean;
  isDisabledVariation: (va: IVariationAttributeModel) => boolean;
  handleSelectVariation: (va: IVariationAttributeModel) => void;
  handleCloseModal: () => void;
  handleDecreaseQuantity: () => void;
  handleIncreaseQuantity: () => void;
  handleSelectSingle: (modifiers: IProductModel[], modi: IProductModel) => void;
  handleSelectMultiple: (modi: IProductModel) => void;
  handleIncreaseModifierQuantity: (modi: IProductModel, modifierGroup: { modifiers: IProductModel[], maxSelectQuantity: number }) => void;
  handleDecreaseModifierQuantity: (modi: IProductModel, modifierGroup: { modifiers: IProductModel[], minSelectQuantity: number }) => void;
  handleAddProduct: () => void;
  notice: { message: string; productIds: number[] };
}
export function AddItemModelViewDesktop({
  openModal,
  currentProductSelected,
  addProduct,
  variationAttributes,
  isDisabledVariation,
  isSelectedVariation,
  handleSelectVariation,
  handleCloseModal,
  handleDecreaseQuantity,
  handleIncreaseQuantity,
  handleSelectSingle,
  handleSelectMultiple,
  handleIncreaseModifierQuantity,
  handleDecreaseModifierQuantity,
  handleAddProduct,
  notice
}: IAddItemModelViewProps) {
  return (
    <ModalComponent
      portalClassName={`ModalAddItemDeskTop`}
      width={800}
      isCustomizeFooter={true}
      onCloseModal={handleCloseModal}
      isModal={true}
      isOpenModal={openModal}
      customizeFooterFixed={
        <div className="total-container modal--footer">
          <button
            onClick={handleAddProduct}
            className="btn--primary"
          >
            <IconShoppingBag width={20} /> ADD TO CART {formatMoney(calculateTotal(addProduct), 2, ".", ",", "$")}
          </button>
        </div>
      }
    >

      <div className="modal-body-scroll">
        <div className="info-product">
          <div className="flex gap-4">
            <div className="ava">
              <div className="img-container img--container-center">
                {currentProductSelected?.product?.images?.length > 0 ? (
                  <img
                    src={redirectFileLocalUrl(
                      currentProductSelected?.product?.images?.length > 0 ? currentProductSelected?.product?.images[0] : "/images/food-place-holder.jpg"
                    )}
                    alt=""
                  />
                ) : (
                  <div className="avatar-thumb h-full w-full bg-yellow-50" />
                )}
              </div>
            </div>
            <div className="flex-auto">
              <div className="name font-bold">
                {currentProductSelected?.product?.name}
              </div>

              <div className="text-red font-bold">
                {formatMoney(
                  currentProductSelected?.product?.variationProducts?.length > 0 ? currentProductSelected?.product.variationProducts.find(x => x.id === addProduct.productId)?.sellingPrice : currentProductSelected?.product?.sellingPrice,
                  2,
                  ".",
                  ",",
                  "$"
                )}
              </div>
              <div className="des">
                {currentProductSelected?.product?.variationProducts?.length > 0 ?
                  (<div dangerouslySetInnerHTML={{ __html: currentProductSelected?.product.variationProducts.find(x => x.id === addProduct.productId)?.description ?? "" }}></div>)
                  :
                  <div dangerouslySetInnerHTML={{ __html: currentProductSelected?.product?.description }}></div>}
              </div>
              <div className="quantity-container">
                <button onClick={handleDecreaseQuantity} className="btn--default">
                  <IconMinus width={20} />
                </button>
                <span>{addProduct?.quantity}</span>
                <button onClick={handleIncreaseQuantity} className="btn--default">
                  <IconPlus width={20} />
                </button>
              </div>
            </div>
          </div>
          {currentProductSelected?.product?.id && notice.message !== "" && notice.productIds.includes(currentProductSelected.product.id) && (
            <div className="promo-banner">
              🎁 When a promotion is applied, remember to choose FREE ITEM(s) at checkout.
            </div>
          )}
        </div>
        {currentProductSelected?.product?.variationProducts?.length > 0 && variationAttributes?.map((vp, vpIdx) => (
          <div key={vpIdx} className="type select-type">
            <div className="label-type">
              {vp.variationName}
            </div>
            <div className="modifier-list">
              {vp.variationAttributes?.map((va) => (
                <div
                  key={va.variationValueId}
                  onClick={() => {
                    if (isDisabledVariation(va)) {
                      return;
                    }
                    handleSelectVariation(va);
                  }}
                  className="item__menu_desk"
                >
                  <div className="info__modifier">
                    <div className="name">
                      {va.variationValueName}
                    </div>
                  </div>
                  <div className="checkbox__content">
                    <div className="checkbox--container">
                      <input
                        type="radio"
                        name={va.variationName}
                        value={va.variationValueId}
                        checked={isSelectedVariation(va)}
                        disabled={isDisabledVariation(va)}
                      />
                      <span
                        className={`checkmark ${isDisabledVariation(va) ? 'disabled' : ''}`}
                        onClick={(e) => {
                          e.stopPropagation();
                          if (isDisabledVariation(va)) {
                            return;
                          }
                          handleSelectVariation(va);
                        }}
                      ></span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
        {/* New UI for product modifier groups with quantity support */}
        {currentProductSelected.product?.modifierGroups?.map((modifierGroup) => {
          // Get all modifier IDs in this modifier group
          const modifierGroupIds = modifierGroup.modifiers.map(m => m.id);

          // Get all selected modifiers that belong to this modifier group
          const selectedModifiersInGroup = addProduct.modifiers?.filter(m =>
            modifierGroupIds.includes(m.productId)
          ) || [];
          // Calculate total quantity of all modifiers in this group
          const totalQuantity = selectedModifiersInGroup.reduce((sum, m) => sum + m.quantity, 0);
          return (
            <div
              key={modifierGroup.modifierGroupId}
              className={`type ${modifierGroup.selectType === SelectGroupTypeEnum.Single
                ? `select-type`
                : `select-modifier`
                }`}
            >
              <div className="label-type quantity-enabled">
                {modifierGroup.name}
                <span className="quantity-badge">
                  Pick {modifierGroup.minSelectQuantity}–{modifierGroup.maxSelectQuantity} options
                </span>
              </div>
              <div className="tooltip-text">
                {totalQuantity} of {modifierGroup.maxSelectQuantity} selected (select at least {modifierGroup.minSelectQuantity})
              </div>
              <div className="modifier-list">
                {modifierGroup?.modifiers?.map((modi) => {
                  const currentModifier = addProduct?.modifiers?.find((m) => m.productId === modi.id);
                  const currentQuantity = currentModifier?.quantity || 0;

                  return (
                    <div
                      key={modi.id}
                      className="item__menu_desk"
                      onClick={() => {
                        if (modi.notAdded) {
                          return;
                        }
                      }}
                    >
                      <div className="info__modifier">
                        <div className="name">
                          {modi.name} {modi.label && (<span style={{ color: "gray", fontWeight: "normal" }}>({modi.label})</span>)}
                        </div>
                      </div>
                      <div className="price">
                        {formatMoney(modi.sellingPrice, 2, ".", ",", "$")}
                      </div>
                      {!modi.notAdded && (
                        <div className="modifier-quantity-controls">
                          <button
                            onClick={(e) => {
                              e.stopPropagation();
                              handleDecreaseModifierQuantity(modi, modifierGroup);
                            }}
                            className="qty-btn-modifier"
                            disabled={currentQuantity === 0}
                          >
                            <IconMinus width={16} />
                          </button>
                          <span className="qty-display-modifier">{currentQuantity}</span>
                          <button
                            onClick={(e) => {
                              e.stopPropagation();
                              handleIncreaseModifierQuantity(modi, modifierGroup);
                            }}
                            className="qty-btn-modifier"
                          >
                            <IconPlus width={16} />
                          </button>
                        </div>
                      )}

                    </div>
                  );
                })}
              </div>
            </div>
          );
        })}
        {currentProductSelected?.modifierGroups?.map((modifierGroup) => {
          return (
            <div
              key={modifierGroup.modifierGroupId}
              className={`type ${modifierGroup.selectType === SelectGroupTypeEnum.Single
                ? `select-type`
                : `select-modifier`
                }`}
            >
              <div className="label-type">
                {modifierGroup.name}
              </div>
              <div className="modifier-list">
                {modifierGroup?.modifiers?.map((modi) => (
                  <div
                    key={modi.id}
                    className="item__menu_desk"
                    onClick={() => {
                      if (modi.notAdded) {
                        return;
                      }
                      if (modifierGroup.selectType === SelectGroupTypeEnum.Single) {
                        handleSelectSingle(modifierGroup.modifiers, modi);
                      } else {
                        handleSelectMultiple(modi);
                      }
                    }}
                  >
                    <div
                      className="info__modifier">
                      <div className="name">
                        {modi.name} {modi.label && (<span style={{ color: "gray", fontWeight: "normal" }}>({modi.label})</span>)}
                      </div>
                    </div>
                    <div className="price">
                      {formatMoney(modi.sellingPrice, 2, ".", ",", "$")}
                    </div>
                    <div className="checkbox__content">
                      {!modi.notAdded && (
                        (
                          <div className="checkbox--container">
                            <input
                              checked={
                                addProduct?.modifiers?.filter(
                                  (m) => m.productId === modi.id
                                ).length > 0
                              }
                              type={modifierGroup.selectType === SelectGroupTypeEnum.Single ? `radio` : `checkbox`}
                              name={modifierGroup.name}
                              value={modi.id}
                            />
                            <span
                              className="checkmark"
                              onClick={(e) => {
                                e.stopPropagation();
                                if (modifierGroup.selectType === SelectGroupTypeEnum.Single) {
                                  handleSelectSingle(modifierGroup.modifiers, modi);
                                } else {
                                  handleSelectMultiple(modi);
                                }
                              }}
                            ></span>
                          </div>
                        )
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          );
        })}
      </div>

    </ModalComponent>
  );
}
